import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { useApi } from '../store/auth.store'

export interface Mailbox {
  id: string
  address?: string
  email?: string
  name: string
  department?: string | null
  provider: 'GMAIL' | 'ZOHO' | 'OUTLOOK' | 'OTHER'
  isActive: boolean
}

export function useMailboxes() {
  const api = useApi()
  return useQuery<Mailbox[]>({
    queryKey: ['mailboxes'],
    queryFn: async () => {
      const res = await api.get<{ mailboxes: Mailbox[] } | Mailbox[]>('/mailboxes')
      if (Array.isArray(res)) return res
      return res?.mailboxes ?? []
    },
    refetchIntervalInBackground: false,
  })
}

export interface ComposeEmailInput {
  mailboxId: string
  to: string[]
  cc?: string[]
  bcc?: string[]
  subject: string
  body: string
  htmlBody?: string
  attachments?: Array<{ id: string; url: string; filename: string; mimeType: string; size: number; localPath: string }>
}

export function useComposeEmail() {
  const api = useApi()
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: ComposeEmailInput) => api.post<{ id: string; message: string }>('/emails/compose', input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['emails'] })
    },
  })
}
